import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import {useTheme} from '@mui/material/styles';

const SelectFiltroRecordatorio = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps,
    isMulti,
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const [options, setOptions] = useState([
        {
            value: 'Asignados',
            label: 'Asignados'
        },
        {
            value: 'Creados',
            label: 'Creados',
        },
        {
            value: 'Todos',
            label: 'Todos',
        },
    ]);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if(typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [options,value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDark ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDark ? '#90caf9' : '#fff')
                : isDark ? '#e0e0e0' : '#000',
            background: state.isSelected 
                ? (isDark ? '#1a3a5c' : '#0364ff')
                : isDark ? '#2d3a52' : '#fff',
            '&:hover': {
                backgroundColor: isDark ? '#3d4a62' : '#02378c',
                color: isDark ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDark ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDark ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDark ? '#3d4a62' : 'gray',
            backgroundColor: isDark ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDark ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDark ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDark ? '#b0bec5' : 'gray',
        }),
    }), [isDark])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectFiltroRecordatorio.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectFiltroRecordatorio